import logo from './logo.svg';
import './App.css';
import { Button, Typography } from 'antd';
const { Title,Paragraph } = Typography;

const appStyle = {
  backgroundColor: '#f0f0f0', // 设置背景颜色
  height: '100vh', // 使背景覆盖整个视口高度
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};


function App() {
  return (
    <div className="App" style={appStyle}>
      
      <Typography>
        <Title>17u71.cc</Title>
        <Paragraph>
          欢迎家人，当你看到此信息时，您已经可以和伙伴们畅所欲言了
        </Paragraph>
      </Typography>
      
    </div>
  );
}

export default App;
